import SafeIcon from '../common/SafeIcon';

const IntegrationCard = ({ integration }) => {
  return (
    <article className={`group rounded-3xl border ${integration.border} bg-slate-900/80 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-blue-400/50 hover:bg-slate-800`}>
      <div className="flex items-start justify-between gap-4">
        <div className={`flex h-14 w-14 items-center justify-center rounded-2xl ${integration.background}`}>
          <SafeIcon name={integration.icon} className={`text-2xl ${integration.color}`} />
        </div>
        <span className="rounded-full border border-slate-700 bg-slate-950/60 px-3 py-1 text-xs font-semibold text-slate-400">
          {integration.category}
        </span>
      </div>

      <h2 className="mt-7 text-2xl font-bold text-white">{integration.name}</h2>
      <p className="mt-3 min-h-20 leading-relaxed text-slate-400">{integration.description}</p>

      <div className="mt-7 flex items-center gap-2 text-sm font-semibold text-blue-400 transition-all group-hover:gap-3">
        Connect your workflow
        <SafeIcon name="ArrowRight" />
      </div>
    </article>
  );
};

export default IntegrationCard;